module.exports = __webpack_public_path__ + "static/pallets-2077f8fab8df7d702ad3213b8871f432.jpg";